import NoticeListPage from "./pages/NoticeListPage";
import NoticeDetailPage from "./pages/NoticeDetailPage";
import NoticeCreatePage from "./pages/NoticeCreatePage";

export const noticeRoutes = (prefix = "notices") => [
  {
    name: "NoticeCreatePage",
    path: `${prefix}/create`,
    component: NoticeCreatePage
  },
  {
    name: "NoticeDetailPage",
    path: `${prefix}/:id`,
    component: NoticeDetailPage
  },
  {
    name: "NoticeListPage",
    path: prefix,
    component: NoticeListPage
  }
];
